export default __webpack_public_path__ + "static/media/BanerMain.26ebaf25.jpg";